import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import ProductTagSubHeader from "../../components/ProductTags/ProductTagSubHeader";
import LeftSideContainer from "./LeftSideContainer";
import RightSideContainer from "./RightSideContainer";
import {
  getProductTags,
  getProductTagDetails,
} from "../../../core/actionCreators/productTagsActionCreator";
import Loader from "../../components/Loader/Loader";

const ProductTagging = () => {
  const dispatch = useDispatch();
  const { productTags, isLoading, productTagDetails } = useSelector(
    (s: any) => s.productTagsStore
  );
  const [pageMode, setPageMode] = useState("edit" as string);
  const [selectedTagId, setSelectedTagId] = useState("" as string);

  useEffect(() => {
    if (productTags.length === 0) {
      dispatch(getProductTags(null, null));
    }
    // Deliberately not keyed on productTagDetails: selecting a tag changes the
    // details, and re-running this would refetch the whole tag list with it.
  }, [productTags, dispatch]);

  // The first tag's details are fetched by the listing saga, not by a click,
  // so the list highlight has to catch up with what is already shown.
  useEffect(() => {
    if (!selectedTagId && productTagDetails?.tagId) {
      setSelectedTagId(productTagDetails.tagId);
    }
  }, [productTagDetails, selectedTagId]);

  const getTagId = (id: string) => {
    setPageMode("edit");
    setSelectedTagId(id);
    dispatch(getProductTagDetails(id, null));
  };

  return (
    <>
      <div className="flex mainWrapper w-full">
        <div className="sidenav-wrapper">
          <SideNavbar />
        </div>
        <div className="right-container">
          <div className="header-container">
            <Header />
          </div>
          <div className="body-container">
            <ProductTagSubHeader />
            <div className="px-4 pb-5">
              {/* Only the very first load blanks the page. Later fetches must
                  leave the panels mounted — unmounting them would discard the
                  form's edit state mid-edit. */}
              {isLoading && productTags.length === 0 ? (
                <div className="bg-white shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded py-12 flex justify-center">
                  <Loader />
                </div>
              ) : (
                <div className="flex gap-5 items-start">
                  <LeftSideContainer
                    productTags={productTags || []}
                    getTagId={getTagId}
                    selectedTagId={selectedTagId}
                  />
                  {/* Keyed on the tag: switching tags is the one case that
                      should reset the form back to read-only. */}
                  <RightSideContainer
                    key={selectedTagId || pageMode}
                    productTagDetails={productTagDetails}
                    pageMode={pageMode}
                    isLoading={isLoading}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductTagging;
